import styled from 'styled-components'
import { Input } from 'antd'

const StyledInput = styled(Input)`
  &.ant-input-affix-wrapper .ant-input,
  &.ant-input {
    border-radius: 4px;

    &:hover,
    &:focus {
      border-color: ${p => p.theme.primary};
    }

    &:focus {
      box-shadow: none;
    }
  }

  &.ant-input-group-wrapper {
    &.custom-input-addon .ant-input-group-addon {
      background: ${p => p.theme.whisper};
      color: ${p => p.theme.darkGrey};
      font-weight: 500;
    }
  }

  &.placeholder-sm {
    .ant-input {
      ::placeholder {
        font-size: 13px;
      }
    }
  }
`

export default StyledInput
